﻿import { DateTime } from 'luxon'
import { make } from './utils'
window.DateTime = DateTime;
import { TabulatorFull as Tabulator } from 'tabulator-tables';

const replaceMe = function (template, value) {
  template = decodeURI(template);
  const pattern = /{\s*(\w+?)\s*}/g;
  return template
	.replaceAll(pattern, value || '')
	.replaceAll('&amp;', '&');
};
const customButton = function (value, formatterParams) {
  let href = replaceMe(formatterParams.url, value);
  let link = make('a', formatterParams.css, {
	href: href,
	innerHTML: formatterParams.text
  });

  if (formatterParams.isBlank) {
	link.target = '_blank';
  }
  return link.outerHTML;
}

Tabulator.extendModule('format', 'formatters', {
  defaultRolesForm: function (cell, formatterParams) {
	let form = make('form', ['flex', 'gap-1'], {
	  method: 'POST',
	  action: formatterParams.url,
	});
	let input = make('input', [], {
	  type: 'hidden',
	  value: cell.getValue(),
	  name: cell.getField()
	});
	let token = make('input', [], {
	  type: 'hidden',
	  value: antiforgeryRequestToken,
	  name: "__RequestVerificationToken",
	});
	let returnPage = make('input', [], {
	  type: 'hidden',
	  value: formatterParams.returnPage,
	  name: "returnPage",
	});
	let changeBtn = make('button', ['btn', 'btn-action', 'btn-outline-amber'], {
	  name: 'changeRoles',
	  type: 'submit',
	  value: 'restore',
	  innerHTML: '<i class="i-mdi-user-key" title="Imposta Ruolo Default"></i>'
	});

	form.appendChild(input);
	form.appendChild(token);
	form.appendChild(returnPage);
	form.appendChild(changeBtn);

	return form.outerHTML;
  },
  deletedForm: function (cell, formatterParams) {
	let form = make('form', ['flex', 'gap-1'], {
	  method: 'POST',
	  action: formatterParams.url,
	});

	let input = make('input', [], {
	  type: 'hidden',
	  value: cell.getValue(),
	  name: cell.getField()
	});
	let token = make('input', [], {
	  type: 'hidden',
	  value: antiforgeryRequestToken,
	  name: "__RequestVerificationToken",
	});
	let restoreBtn = make('button', ['btn', 'btn-action', 'btn-outline-green'], {
	  name: 'deletedAction',
	  type: 'submit',
	  value: 'restore',
	  innerHTML: '<i class="i-mdi-delete-restore" title="Ripristina" onclick="return confirm(\'Sei sicuro di voler ripristinare questo elemento?\')"></i>'
	});
	let deleteBtn = make('button', ['btn', 'btn-action', 'btn-outline-red'], {
	  name: 'deletedAction',
	  type: 'submit',
	  value: 'delete',
	  innerHTML: '<i class="i-mdi-delete" title="Elimina Definitivamente" onclick="return confirm(\'Sei sicuro di voler eliminare definitivamente questo elemento?\')"></i>'
	});
	
	form.appendChild(input);
	form.appendChild(restoreBtn);
	form.appendChild(deleteBtn);
	form.appendChild(token);

	return form.outerHTML;
  },
  obj: function (cell, formatterParams) {
	let space = formatterParams.space ?? 0;
	if (space != 0) {
	  let container = make('div', ['whitespace-pre'], {
		innerHTML: JSON.stringify(cell.getValue(), null, space)
	  });
	  return container.outerHTML;
	}
	return JSON.stringify(cell.getValue());

  },
  list: function (cell, formatterParams) {
	let separator = formatterParams.separator ?? ', ';
	let container = make('div', ['text-pretty'], {
	  innerHTML: cell.getValue().join(separator)
	});
	return container.outerHTML;
  },
  objList: function (cell, formatterParams) {
	let separator = formatterParams.separator ?? ', ';
	let array = cell.getValue().map(x => JSON.stringify(x));
	return array.join(separator)
  },
  'select-button': function (cell, formatterParams) {
	let button = make('button', ['btn', 'btn-outline-amber'], {
	  type: 'button'
	})
	button.innerHTML = '<i class="i-mdi-task-add"></i><span>Seleziona</span>';
	button.dataset.selectButton = cell.getValue();

	return button.outerHTML;
  },
  'is-public': function (cell, formatterParams) {
	let data = cell.getData();
	let container = make('div', ['flex', 'flex-col', 'items-center']);
	let icon;
	if (data.isPublic) {
	  icon = make('i', ['i-mdi-check-circle', 'text-green-600'], { title: 'Pubblico' });
	} else {
	  icon = make('i', ['i-mdi-close-circle', 'text-red-600'], { title: 'NON Pubblico' });
	}
	container.appendChild(icon);

	if (data.startDate !== null) {
	  let startDate = make('small');
	  let date = new Date(data.startDate)
	  startDate.innerHTML = `Dal ${date.toLocaleDateString('it')}`;
	  container.appendChild(startDate);
	}
	if (data.endDate !== null) {
	  let endDate = make('small');
	  let date = new Date(data.endDate)
	  endDate.innerHTML = `Al ${date.toLocaleDateString('it')}`;
	  container.appendChild(endDate);
	}

	return container.outerHTML;
  },
  'custom-button': function (cell, formatterParams) {
	let value = cell.getValue();
	return customButton(value, formatterParams);
  },
  'edit-button': function (cell, formatterParams) {
	let defaultParams = {
	  text: '<i class="i-mdi-pencil-box" title="Modifica"></i>',
	  css: 'btn btn-action btn-outline-blue '
	}
	let value = cell.getValue();
	return customButton(value, { ...defaultParams, ...formatterParams });
  },
  'delete-button': function (cell, formatterParams) {
	let defaultParams = {
	  text: '<i class="i-mdi-delete" title="Elimina"></i>',
	  css: 'btn btn-action btn-outline-red'
	}
	let value = cell.getValue();
	return customButton(value, { ...defaultParams, ...formatterParams });
  },
  'details-button': function (cell, formatterParams) {
	let defaultParams = {
	  text: '<i class="i-mdi-eye-circle" title="Dettagli"></i>',
	  css: 'btn btn-action btn-outline-yellow'
	}
	let value = cell.getValue();
	return customButton(value, { ...defaultParams, ...formatterParams });
  },
  'duplicate-button': function (cell, formatterParams) {
	let defaultParams = {
	  text: '<i class="i-mdi-content-duplicate" title="Duplica"></i>',
	  css: 'btn btn-action btn-outline-green'
	}
	let value = cell.getValue();
	return customButton(value, { ...defaultParams, ...formatterParams });
  },
  'accounts-button': function (cell, formatterParams) {
	let defaultParams = {
	  text: '<i class="i-mdi-account-multiple" title="Accounts"></i>',
	  css: 'btn btn-action btn-outline-sky'
	}
	let value = cell.getValue();
	return customButton(value, { ...defaultParams, ...formatterParams });
  },
  'updateversion-button': function (cell, formatterParams) {
	let defaultParams = {
	  text: '<i class="i-mdi-plus-one" title="Incrementa Versione"></i>',
	  css: 'btn btn-action btn-outline-amber'
	}
	let value = cell.getValue();
	return customButton(value, { ...defaultParams, ...formatterParams });
  },
  'steps-button': function (cell, formatterParams) {
	let defaultParams = {
	  text: '<i class="i-mdi-format-list-numbered" title="Steps"></i>',
	  css: 'btn btn-action btn-outline-sky'
	}
	let value = cell.getValue();
	return customButton(value, { ...defaultParams, ...formatterParams });
  },
  'colored-text': function (cell, formatterParams) {
	let data = cell.getValue();

	let color = data[formatterParams.color];
	let text = data[formatterParams.text];

	let span =  make('span', null, {
	  style: `color:${color}`,
	  innerHTML: text
	});

	return span.outerHTML;
  },
  'colored-background': function (cell, formatterParams) {
	let data = cell.getValue();

	let color = data[formatterParams.color];
	let text = data[formatterParams.text];

	let element = cell.getElement();
	element.style.backgroundColor = color;
	
	let span = make('span', null, {
	  style: `color:${color}; mix-blend-mode: difference;`,
	  innerHTML: text
	});

	return span.outerHTML;
  },
  'is-online': function (cell, formatterParams) {
	let data = cell.getValue();

	let icon = make('i', ['i-mdi-offline', 'text-red-600'], { title: 'Offline' });
	let delay = formatterParams?.seconds ?? 300;

	let lastOnline = DateTime.fromSQL(data, { zone: 'UTC' });
	if (!lastOnline.invalid) {

	  let now = DateTime.now().toUTC();
	  let difference = now.diff(lastOnline, 'seconds');
	  let isOnline = difference.seconds <= delay;

	  if (isOnline) {
		icon = make('i', ['i-mdi-account-online', 'text-green-600'], { title: 'Online' });
	  }

	  setTimeout(() => {
		cell.getElement().innerHTML = make('i', ['i-mdi-offline', 'text-red-600'], { title: 'Offline' }).outerHTML;
	  }, delay * 1000)
	}

	return icon.outerHTML;
  }
});

export const tabulator = {
  init: function (selector, options) {
	options = { ...tabulator.defaultOptions, ...options }
	options.ajaxConfig.headers['RequestVerificationToken'] = antiforgeryRequestToken;
	return new Tabulator(selector, options);
  },
  moveRow: function (fromIndex, toIndex, options) {
	let data = new FormData();
	data.append('elementType', options.elementType);
	if (options.elementId) {
	  data.append('elementId', options.elementId);
	}
	data.append('origin', fromIndex);
	data.append('target', toIndex);

	return fetch(`/api/sortable/sort`, {
	  method: 'POST',
	  headers: { 'RequestVerificationToken': antiforgeryRequestToken },
	  body: new URLSearchParams(data)
	})
	  .then(response => response.text())
	  .catch((errors) => { console.error(errors); });
  },
  defaultOptions: {
	locale: 'it',
	langs: {
	  'it': {
		'data': {
		  'loading': 'Caricamento...',
		  'error': 'Errore',
		},
		'groups': {
		  'item': 'elemento',
		  'items': 'elementi',
		},
		'pagination': {
		  'page_size': 'Visualizza',
		  'page_title': 'Elementi per pagina',
		  'first': '<i class="i-mdi-page-first"></i>',
		  'first_title': 'Prima pagina',
		  'last': '<i class="i-mdi-page-last"></i>',
		  'last_title': 'Ultima pagina',
		  'prev': '<i class="i-mdi-chevron-left"></i>',
		  'prev_title': 'Pagina precedente',
		  'next': '<i class="i-mdi-chevron-right"></i>',
		  'next_title': 'Pagina successiva',
		  'all': 'All',
		  'counter': {
			'showing': 'Visualizza',
			'of': 'di',
			'rows': 'elementi',
			'pages': 'pagine',
		  }
		},
		'headerFilters': {
		  'default': 'Filtra...'
		}
	  }
	},
	columnDefaults: {
	  vertAlign: 'middle',
	  resizable: 'header',
	},
	resizableRows: false,
	selectableRows: false,
	renderVertical: 'basic',
	layout: 'fitColumns',
	responsiveLayout: 'hide',
	ajaxConfig: {
	  method: 'POST',
	  headers: {}
	},
	filterMode: 'remote',
	sortMode: 'remote',
	pagination: true,
	paginationMode: 'remote',
	paginationSize: 20,
	paginationSizeSelector: [5, 10, 20, 50],
	paginationCounter: 'rows',
	placeholder: 'Nessun elemento disponibile',
	placeholderHeaderFilter: 'Nessun elemento disponibile in base ai filtri impostati',
	persistence: {
	  sort: true,
	  filter: false,
	  headerFilter: true,
	  group: false,
	  page: true,
	  columns: false,
	}
  }
}

